import {Sprite, Text} from 'pixi.js';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';
import {Button, consoleLogger, DeviceType, ObjectBuilder, setLayer} from '@gongxigames/framework/core';
import {UIElements, UIElementsSwapLayerEvent} from '@gongxigames/framework/slot/events';
import {KeypadControlsView} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsView';
import {KeypadView, KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad';

export class KeypadControlsViewMobileLandscape extends KeypadControlsView {
    public static readonly NAME: symbol = Symbol('KeypadControlsViewMobileLandscape');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    public static readonly TOTAL_BET_WINDOW_CLICKED: symbol = Symbol('__TOTAL_BET_WINDOW_CLICKED__');
    public static readonly HOME_CLICKED: symbol = Symbol('HOME_CLICKED');

    protected _totalBetWindow!: Sprite;
    protected _totalBetOpenButton!: Button;
    protected _menuButton!: Button;
    protected _homeButton!: Button;

    public init(): void {
        this.initGraphicElements();
        this.initCallbacks();

        this.mainSprite.addChildAt(this._totalBetWindow, 0);
    }

    protected initGraphicElements(): void {
        this.setTotalBetWindow();

        this._totalBetPanel = this.mainSprite.getChildByName<Sprite>('totalBetPanel', true);
        this._menuButton = this.mainSprite.getChildByName<Button>('menuButton');
        this._homeButton = this.mainSprite.getChildByName<Button>('homeButton');
        this._betIncButton = this._totalBetWindow.getChildByName<Button>('plusButton');
        this._betDecButton = this._totalBetWindow.getChildByName<Button>('minusButton');
        this._betValueText = this._totalBetWindow.getChildByName<Text>('fieldText');
        this._totalBetOpenButton = this.mainSprite.getChildByName<Button>('betButton');

        this.setupTurboCheckbox();
    }

    public swapUIElementsLayer({layer, element}: UIElementsSwapLayerEvent): void {
        if (element === UIElements.TOTAL_BET_PANEL) {
            setLayer(layer, this._totalBetPanel, this._totalBetOpenButton, this._betIncButton, this._betDecButton);
        }
    }

    protected setupTurboCheckbox(): void {
    }

    public disableForeverTurboCheckbox(): void {

    }

    public hideBetPanel(): void {
        this._totalBetPanel.visible = false;
    }

    public showBetPanel(): void {
        this._totalBetPanel.visible = true;
    }

    public setTotalBetWindow(): void {
        const rootName = 'balanceBar';
        const config = this._objectBuilder.getDisplayObjectConfigByName(rootName);

        if (config) {
            this._totalBetWindow = this._objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.balanceBar);
            this._totalBetWindow.visible = false;
        } else {
            consoleLogger.warn(`No Sprite - '${rootName}'. Please, check resources!`);
        }
    }

    protected initCallbacks(): void {
        if (this.getSettings<SlotSettings>().has('homeUrl')) {
            this._homeButton.callback = this.onHomeButtonClicked.bind(this);
        } else {
            this._homeButton.visible = false;
        }

        // this._autoplayButton.callback = this.onAutoplayButtonClicked.bind(this);
        this._betDecButton.callback = this.onDecBetButtonClicked.bind(this);
        this._betIncButton.callback = this.onIncBetButtonClicked.bind(this);
        // this._turboCheckbox.changedCallback = this.onTurboCheckboxClicked.bind(this);
        this._totalBetOpenButton.callback = this.onOpenTotalBetClicked.bind(this);

        /* develblock:start */
        this._cli.addCommand('disableTurbo', () => this._turboCheckbox.setValue(false, true));
        this._cli.addCommand('enableTurbo', () => this._turboCheckbox.setValue(true, true));
        /* develblock:end */
    }

    protected onHomeButtonClicked(): void {
        this.soundPlayer.play('buttonclick');
        this.emit(KeypadControlsViewMobileLandscape.HOME_CLICKED);
    }

    protected onOpenTotalBetClicked(): void {
        this.soundPlayer.play('buttonclick');
        this.emit(KeypadControlsViewMobileLandscape.TOTAL_BET_WINDOW_CLICKED);
    }

    public openTotalBetWindow(): void {
        this._totalBetWindow.visible = true;
    }

    public closeTotalBetWindow(): void {
        this._totalBetWindow.visible = false;
    }

    public setBetValueText(text: string): void {

    }

    public enableAutoplayButton(): void {
    }

    public disableAutoplayButton(): void {
    }

    protected showAutoplayButton(): void {
    }

    protected hideAutoplayButton(): void {
    }

    protected showTurboCheckbox(): void {
    }

    protected hideTurboCheckbox(): void {
    }

    public enableTurboCheckbox(): void {
    }

    public disableTurboCheckbox(): void {
    }

    public updateTurboCheckbox(isOn: boolean): void {
    }

    public enableInfoButton(): void {
    }

    public disableInfoButton(): void {
    }

    public enableMenuButton(): void {
        this._menuButton.enable();
    }

    public disableMenuButton(): void {
        this._menuButton.disable();
    }

    public enableTotalBetOpenButton(): void {
        this._totalBetOpenButton.enable();
    }

    public disableTotalBetOpenButton(): void {
        this._totalBetOpenButton.disable();
    }

    public hideTotalBetOpenButton(): void {
        this._totalBetOpenButton.visible = false;
    }

    public showTotalBetOpenButton(): void {
        this._totalBetOpenButton.visible = true;
    }

    public enableHomeButton(): void {
        this._homeButton.enable();
    }

    public disableHomeButton(): void {
        this._homeButton.disable();
    }

    public set menuButton(value: Button) {
        this._menuButton = value;
    }

    public set homeButton(value: Button) {
        this._homeButton = value;
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [...super.getViewDependencies(), KeypadViewMobileLandscape.NAME];
    }
}
